// Top Level paths for each Flow
export const FLOW_PATHS = {
  applyStrLicense: '/apply-str-license',
}
